<template>
  <el-menu :default-active="menuIndex" :router="true" class="con-menu" mode="horizontal">
    <el-menu-item v-for="(c, i) in menu" :key="i" :index="c.path" :class="[menuIndex === c.path ? 'active' : '']">{{
    c.name }}</el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "TabMenu",
  props: {
    menuIndex: String,
    menu: Array,
  },
  data() {
    return {};
  },
  methods: {},
  watch: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
.con-menu.el-menu.el-menu--horizontal {
  background: none;
  border: 0 none;
  margin-bottom: 15px;

  .el-menu-item {
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    border-bottom-width: 3px;
    margin: 0 10px;
    color: #606266;

    &:hover {
      color: #2691FF;
      background: transparent;
    }

    &:nth-of-type(2) {
      border-left-width: 0;
    }

    &.is-active {
      color: #2691FF;
      background: transparent;
      // color: #606266;
      // border-color: transparent !important;
    }

    // &.active {
    //   color: #2691FF;
    //   background: transparent;
    //   border-color: #2691FF !important;
    // }
  }
}
</style>
